import { productList } from "constants/product";
import * as API from "../API/index";
import { authorizedUser } from "components/CommonComponent/CommonFunction";

export const getProductList = async (dispatch, pageNum, filters) => {
  try {
    const res = await API.product_list(pageNum, filters);
    dispatch({ type: productList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: productList,
      payload: error?.response?.data || error,
    });
  }
};
